import { CurrencyUtil } from '@axiom/utils';

import type { CandidateDetail } from '../api/chat-api';

/**
 * MatchGridUtil - I turn a candidate's numbers into the text its cells read.
 * ONLY concerned with formatting - the cells that render markup are components of their own.
 */
export const MatchGridUtil = {
  /** Shown wherever the grid has a column but the response has no value for it. */
  NOT_YET: '--',

  formatPricingRange({
    currencyType,
    fullTimeHourlyRate,
    variableHourlyRate,
  }: Pick<
    CandidateDetail,
    'currencyType' | 'fullTimeHourlyRate' | 'variableHourlyRate'
  >) {
    const rates = [variableHourlyRate, fullTimeHourlyRate]
      .filter((rate): rate is number => typeof rate === 'number')
      .map(rate => Math.round(rate));

    if (rates.length === 0) return MatchGridUtil.NOT_YET;

    const low =
      CurrencyUtil.getFormattedCurrency({
        currencyCode: currencyType,
        value: Math.min(...rates),
      }) ?? MatchGridUtil.NOT_YET;
    const high =
      CurrencyUtil.getFormattedCurrency({
        currencyCode: currencyType,
        value: Math.max(...rates),
      }) ?? MatchGridUtil.NOT_YET;

    return low === high ? low : `${low}–${high}`;
  },

  formatCompensation({
    compensation,
    currencyType,
  }: Pick<CandidateDetail, 'compensation' | 'currencyType'>) {
    return (
      CurrencyUtil.getFormattedCurrency({
        currencyCode: currencyType,
        value: compensation,
      }) ?? MatchGridUtil.NOT_YET
    );
  },
};
